import type { ProjectMembersSlice } from './projects.type'

export const projectMembersInitialState: Pick<
  ProjectMembersSlice,
  'projectMembersError' | 'projectMembersPending' | 'projectMembersReadyProjectId' | 'projectMembersServer'
> = {
  projectMembersServer: [],
  projectMembersPending: [],
  projectMembersReadyProjectId: null,
  projectMembersError: null,
}
